export const STATE_NAME = 'inboxCounter';

export enum ActionTypes {
  START = '[InboxCounter] START',
  DONE = '[InboxCounter] DONE',
  FAIL = '[InboxCounter] FAIL',
}
